import { lazy } from "react";
import { accountRoutes } from "./accountRoutes.js";
import { adminRoutes } from "./adminRoutes.electron.js";

export const indexElectron = [
    ...accountRoutes,
    //...errorRoutes,
    // ...aboutRoutes,
    ...adminRoutes,
];

export default indexElectron;
